import { HttpParams } from "@angular/common/http";

export class HttpParamsUtil {

    public static buildHttpParams(obj: any): HttpParams {
        let params = new HttpParams();

        Object.keys(obj).forEach(key => {
            const value = obj[key];
            if (value !== null && value !== undefined) {
                params = params.set(key, value);
            }
        });

        return params;
    }
}